import React from 'react'
import Link from 'gatsby-link'
import { Helmet } from "react-helmet";

import Block from '../components/block';
import Title from '../components/my-title';

import BlockCover from '../components/block-cover';
import BlockExpertise from '../components/block-expertise';

import UsExpertiseImage from '../assets/us-expertise.jpg';

const data = [
  /*{
    imageUrl: '/expertise/sur-mesure.jpg',
    imageAlt: 'Sur mesure',
    title: 'Sur mesure',
    content: (
      <p>Nous réalisons dans notre atelier tout type de fabrication sur mesure. Faites nous part de votre projet.</p>
    ),
    link: '/realisations/sur-mesure'
  },*/
  {
    imageUrl: '/expertise/cuisine.jpg',
    imageAlt: 'Cuisine',
    title: 'Cuisine',
    content: (
      <p>Votre cuisine customisée, avec façades et finitions faites main sur une base de caissons industriels pour une parfaite maîtrise de votre budget.</p>
    ),
    link: '/realisations/cuisine'
  },
  {
    imageUrl: '/expertise/salle-de-bain.jpg',
    imageAlt: 'Salle de bain',
    title: 'Salle de bain',
    content: (
      <p>La fabrication complète de votre salle de bain en mélaminé hydrofuge parfaitement adapté, avec des façades sur mesure.</p>
    ),
    link: '/realisations/salle-de-bain'
  },
  {
    imageUrl: '/expertise/bibliotheque.jpg',
    imageAlt: 'Bibliothèque',
    title: 'Bibliothèque',
    content: (
      <p>Entièrement réalisée sur mesure selon vos envies, une bibliothèque pleine d’astuces qui peut même intégrer un éclairage ou votre téléviseur.</p>
    ),
    link: '/realisations/bibliotheque'
  },
  {
    imageUrl: '/expertise/dressing.jpg',
    imageAlt: 'Dressing et aménagement de placards',
    title: 'Dressing et aménagement de placards',
    content: (
      <p>Une fabrication sur mesure pour optimiser votre espace et créer un rangement parfaitement rationnel qui correspond à vos envies.</p>
    ),
    link: '/realisations/dressing-placard'
  },
  {
    imageUrl: '/expertise/tete-de-lit.jpg',
    imageAlt: 'Tête de lit',
    title: 'Tête de lit',
    content: (
      <p>L’intégration harmonieuse de votre tête de lit avec lumière et rangement à façon pour parfaire l’esthétique de votre chambre à coucher.</p>
    ),
    link: '/realisations/tete-de-lit'
  },
  {
    imageUrl: '/expertise/escalier-beton.jpg',
    imageAlt: 'Habillage escalier',
    title: 'Habillage escalier',
    content: (
      <p>L’esthétique chaleureuse et la longévité exceptionnelle d’un habillage sur mesure en chêne massif de première qualité.</p>
    ),
    link: '/realisations/escalier'
  },
  {
    imageUrl: '/expertise/parquet.jpg',
    imageAlt: 'Parquet',
    title: 'Parquet',
    content: (
      <p>Un très vaste choix de bois et de techniques de pose pour un sol aussi beau que résistant, dont vous profiterez très longtemps.</p>
    ),
    link: '/realisations/parquet'
  },
  {
    imageUrl: '/expertise/terrasse.jpg',
    imageAlt: 'Terrasse',
    title: 'Terrasse',
    content: (
      <p>Une construction durable, réalisée à partir des plus beaux bois, pour profiter toute l'année de votre jardin et de votre terrasse.</p>
    ),
    link: '/realisations/terrasse'
  },
  {
    imageUrl: '/expertise/divers.jpg',
    imageAlt: 'Aménagement divers',
    title: 'Aménagement divers',
    content: (
      <p>La réalisation sur mesure de vos demandes les plus spécifiques grâce à un échange de chaque instant sur les solutions les plus adaptées.</p>
    ),
    link: '/realisations/divers'
  },
  {
    imageUrl: '/expertise/ebenisterie.jpg',
    imageAlt: 'Ébénisterie',
    title: 'Ébénisterie',
    content: (
      <p>Les plus nobles essences, les plus beaux bois et la maîtrise parfaite de leur travail pour créer sur mesure tout ce qui vous tient à cœur.</p>
    ),
    link: '/realisations/ebenisterie'
  },
];

const Expertise = () => (
  <div>
    <Helmet>
      <title>Didier Bré : Meubles sur mesure, menuiserie et ébénisterie</title>
      <meta name="description" content="réalisation de tout type de meuble sur mesure" />
    </Helmet>
    <BlockCover
      backgroundUrl={UsExpertiseImage}
      title="Nos expertises"
      repeatedTitle={true} />

    <Block hasDecoration>
      <Title small>Ce que nous faisons</Title>
    </Block>

    <div className="expertise-list">
      {data.map((item, index) => (
        <BlockExpertise {...item} key={index}>
          {item.content}
        </BlockExpertise>
      ))}
    </div>
  </div>
)

export default Expertise



// WEBPACK FOOTER //
// ./src/pages/expertise.js